import actions from "./actions";
import state from "./state";
import mutations from "./mutations";

const getters = {
  getCompanyAwayDetailList: (state) => state.items,
  getCompanyAwayDetailListPagination: (state) => state.pagination,
  getCompanyAwayDetailListPage: (state) => state.pagination.current_page,
};

export default {
  state,
  actions,
  mutations,
  getters,
};
